import { borrowerPortalLoginUrl } from '@mortgage-pos/data'
import { Routes } from '@mortgage-pos/types'
import { environment } from '@mortgage-pos/ui/env'
import { redirectTo } from '@mortgage-pos/utils'

export const handleSignInOutClick = async (
  isAuthenticated,
  loginWithRedirect,
  auth0Logout,
  borrowerPortalLogout
) => {
  if (
    environment.productName === 'sage' ||
    environment.productName === 'sage-home-loans'
  ) {
    if (isAuthenticated) {
      auth0Logout()
      await borrowerPortalLogout()
    } else {
      redirectTo(borrowerPortalLoginUrl)
    }
  } else {
    if (isAuthenticated) {
      auth0Logout()
      await borrowerPortalLogout()
    } else {
      loginWithRedirect({
        redirectUri: `${window.location.origin}/${Routes.APP_1003}/continue`,
      })
    }
  }
}
